export default __webpack_public_path__ + "static/img_product_readingn@2x-e9be072802a163d9c65fcf22b0819662.png";